// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3XjCf","footer":"ModalError_footer__35p2o"};